import axios from 'axios';
import moment from 'moment';
export const imagepath = "https://debaintl.com/debba/api/storage/app/public/"
export const baseURL = "https://debaintl.com/debba/api"

// export const imagepath = "http://localhost:8000/api/storage/app/public/"
// export const baseURL = "http://localhost:8000/api"

const api = axios.create({
  baseURL: baseURL, // Single entry point for API
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to include Bearer token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to always return { success, message, data }
api.interceptors.response.use(
  (response) => {
    // If the response is already in the correct format, return as is
    if (
      typeof response.data === 'object' &&
      'success' in response.data &&
      'message' in response.data &&
      'data' in response.data
    ) {
      return response.data;
    }
    // Otherwise, wrap it
    return {
      success: true,
      message: 'Success',
      data: response.data,
    };
  },
  (error) => {
    // Handle error responses
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    const payload = error.response?.data;
    const mergedData = (payload && typeof payload === 'object')
      ? (payload.data !== undefined ? payload.data : payload)
      : null;
    return Promise.resolve({
      success: false,
      message: payload?.message || error.message || 'Error',
      data: mergedData,
    });
  }
);

// Departments
export const getDepartments = () => api.get('/departments');

// Employees
export const createEmployee = (data) => api.post('/employees', data, { headers: { 'Content-Type': 'multipart/form-data' } });
export const getEmployees = () => api.get('/employees');
export const getEmployee = (id) => api.get(`/employees/${id}`);
export const updateEmployee = (id, data) => api.post(`/employees/${id}?_method=PUT`, data, { headers: { 'Content-Type': 'multipart/form-data' } });
export const deleteEmployee = (id) => api.delete(`/employees/${id}`);

// Employee Documents
export const uploadEmployeeDocument = (employeeId, data) => {
  const formData = new FormData();
  formData.append('document_type', data.document_type);
  formData.append('expiry_date', data.expiry_date);
  formData.append('document_file', data.document_file);
  return api.post(`/employees/${employeeId}/documents`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

export const bulkUploadEmployeeDocuments = (employeeId, documents) => {
  const formData = new FormData();

  documents.forEach((doc, index) => {
    formData.append(`documents[${index}][document_type]`, doc.document_type);
    if (doc.issue_date) formData.append(`documents[${index}][issue_date]`, doc.issue_date);
    if (doc.expiry_date) formData.append(`documents[${index}][expiry_date]`, doc.expiry_date);
    formData.append(`documents[${index}]`, doc.document_file);
  });

  return api.post(`/employees/${employeeId}/documents/bulk`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

export const deleteEmployeeDocument = (employeeId, documentId) =>
  api.delete(`/employees/${employeeId}/documents/${documentId}`);

// Subcontractors
export const getSubcontractors = () => api.get('/subcontractors');
export const createSubcontractor = (data) => api.post('/subcontractors', data);
export const updateSubcontractor = (id, data) => api.put(`/subcontractors/${id}`, data);
export const deleteSubcontractor = (id) => api.delete(`/subcontractors/${id}`);
export const getSubcontractor = (id) => api.get(`/subcontractors/${id}`);
export const bulkUploadSubcontractorDocuments = (subcontractorId, documents) => {
  const formData = new FormData();
  documents.forEach((doc, index) => {
    formData.append(`documents[${index}][document_type]`, doc.document_type);
    if (doc.expiry_date) formData.append(`documents[${index}][expiry_date]`, doc.expiry_date);
    if (doc.remarks) formData.append(`documents[${index}][remarks]`, doc.remarks);
    formData.append(`documents[${index}]`, doc.document_file);
  });
  return api.post(`/subcontractors/${subcontractorId}/documents/bulk`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};
export const deleteSubcontractorDocument = (subcontractorId, documentId) =>
  api.delete(`/subcontractors/${subcontractorId}/documents/${documentId}`);

// Subcontractor Employees
export const getSubcontractorEmployees = (subcontractor_id) => api.get('/subcontractor_employees', { params: { subcontractor_id } });
export const createSubcontractorEmployee = (data) => api.post('/subcontractor_employees', data, { headers: { 'Content-Type': 'multipart/form-data' } });
export const updateSubcontractorEmployee = (id, data) => api.post(`/subcontractor_employees/${id}?_method=PUT`, data, { headers: { 'Content-Type': 'multipart/form-data' } });
export const deleteSubcontractorEmployee = (id) => api.delete(`/subcontractor_employees/${id}`);

export const bulkUploadSubcontractorEmployeeDocuments = (employeeId, documents) => {
  const formData = new FormData();
  documents.forEach((doc, index) => {
    formData.append(`documents[${index}][document_type]`, doc.document_type);
    if (doc.issue_date) formData.append(`documents[${index}][issue_date]`, doc.issue_date);
    if (doc.expiry_date) formData.append(`documents[${index}][expiry_date]`, doc.expiry_date);
    formData.append(`documents[${index}][document_file]`, doc.document_file);
  });
  return api.post(`/subcontractor_employees/${employeeId}/documents/bulk`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

export const deleteSubcontractorEmployeeDocument = (employeeId, documentId) =>
  api.delete(`/subcontractor_employees/${employeeId}/documents/${documentId}`);

// Clients
export const getClients = () => api.get('/clients');
export const getClient = (id) => api.get(`/clients/${id}`);
export const createClient = (data) => api.post('/clients', data, { headers: { 'Content-Type': 'multipart/form-data' } });
export const updateClient = (id, data) => api.post(`/clients/${id}?_method=PUT`, data, { headers: { 'Content-Type': 'multipart/form-data' } });
export const deleteClient = (id) => api.delete(`/clients/${id}`);

export const bulkUploadClientDocuments = (clientId, documents) => {
  const formData = new FormData();
  documents.forEach((doc, index) => {
    formData.append(`documents[${index}][document_type]`, doc.document_type);
    if (doc.issue_date) formData.append(`documents[${index}][issue_date]`, doc.issue_date);
    if (doc.expiry_date) formData.append(`documents[${index}][expiry_date]`, doc.expiry_date);
    if (doc.remarks) formData.append(`documents[${index}][remarks]`, doc.remarks);
    formData.append(`documents[${index}]`, doc.document_file);
  });
  return api.post(`/clients/${clientId}/documents/bulk`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};
export const deleteClientDocument = (clientId, documentId) =>
  api.delete(`/clients/${clientId}/documents/${documentId}`);


// LPOs
export const getLpos = (params) => api.get('/lpos', { params });
export const getLpo = (id) => api.get(`/lpos/${id}`);
export const createLpo = (data) => api.post('/lpos', data, { headers: { 'Content-Type': 'multipart/form-data' } });
export const updateLpo = (id, data) => api.post(`/lpos/${id}?_method=PUT`, data, { headers: { 'Content-Type': 'multipart/form-data' } });
export const deleteLpo = (id) => api.delete(`/lpos/${id}`);

export const createLpoTransaction = (lpoId, data) => api.post(`/lpos/${lpoId}/transactions`, data, { headers: { 'Content-Type': 'multipart/form-data' } });
export const updateLpoTransaction = (id, data) => api.post(`/lpo-transactions/${id}?_method=PUT`, data, { headers: { 'Content-Type': 'multipart/form-data' } });
export const deleteLpoTransaction = (id) => api.delete(`/lpo-transactions/${id}`);

export const downloadLpoStatement = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const response = await fetch(`${api.defaults.baseURL}/lpos/${id}/statement`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/pdf',
      },
    });

    if (!response.ok) {
      throw new Error('Failed to download LPO statement');
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;

    const disposition = response.headers.get('content-disposition') || response.headers.get('Content-Disposition') || '';
    const match = disposition.match(/filename="?([^";]+)"?/);
    const filename = match ? match[1] : `LPO_Statement_${id}.pdf`;

    link.download = filename;
    document.body.appendChild(link);
    link.click();
    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }, 200);
  } catch (error) {
    console.error('Download error:', error);
    throw error;
  }
};

// Client Departments
export const getClientDepartments = (client_id) => api.get('/client_departments', { params: { client_id } });
export const createClientDepartment = (data) => api.post('/client_departments', data);
export const updateClientDepartment = (id, data) => api.put(`/client_departments/${id}`, data);
export const deleteClientDepartment = (id) => api.delete(`/client_departments/${id}`);

// Employee Assignments
export const getEmployeeAssignments = (params) => api.get('/employee_assignments', { params });
export const createEmployeeAssignments = (data) => api.post('/employee_assignments', data);
export const deleteEmployeeAssignment = (id) => api.delete(`/employee_assignments/${id}`);

// Employee Timesheets
export const getEmployeeTimesheets = (params) => api.get('/employee_timesheets', { params });
export const createEmployeeTimesheets = (data) => api.post('/employee_timesheets', data);
export const updateEmployeeTimesheet = (id, data) => api.put(`/employee_timesheets/${id}`, data);
export const deleteEmployeeTimesheet = (id) => api.delete(`/employee_timesheets/${id}`);

// Employee Timesheet Overview (assignments + timesheets in one call)
export const getEmployeeTimesheetOverview = (params) => api.get('/employee_timesheet_overview', { params });

// Skills
export const getSkills = () => api.get('/skills');
export const createSkill = (data) => api.post('/skills', data);
export const updateSkill = (id, data) => api.put(`/skills/${id}`, data);
export const deleteSkill = (id) => api.delete(`/skills/${id}`);

// Vehicles
export const getVehicles = () => api.get('/vehicles');
export const createVehicle = (data) => api.post('/vehicles', data, { headers: { 'Content-Type': 'multipart/form-data' } });
export const updateVehicle = (id, data) => api.post(`/vehicles/${id}?_method=PUT`, data, { headers: { 'Content-Type': 'multipart/form-data' } });
export const deleteVehicle = (id) => api.delete(`/vehicles/${id}`);

// Licenses
export const getLicenses = () => api.get('/licenses');
export const createLicense = (data) => api.post('/licenses', data);
export const updateLicense = (id, data) => api.put(`/licenses/${id}`, data);
export const deleteLicense = (id) => api.delete(`/licenses/${id}`);

// Payroll
export const getPayrolls = (params) => api.get('/payrolls', { params });
export const generatePayroll = (data) => api.post('/payrolls/generate', data);
export const exportPayrollsPdf = async (data) => {
  const token = localStorage.getItem('token');
  const response = await fetch(`${api.defaults.baseURL}/payrolls/export-pdf`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
      'Accept': 'application/pdf',
    },
    body: JSON.stringify(data)
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.message || 'Failed to generate PDF');
  }

  return response.blob();
};
export const bulkGeneratePayroll = (data) => api.post('/payrolls/bulk-generate', data);
export const updatePayroll = (id, data) => api.put(`/payrolls/${id}/update`, data);
export const deletePayroll = (id) => api.delete(`/payrolls/${id}`);
export const downloadSalarySlip = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const response = await fetch(`${api.defaults.baseURL}/payrolls/${id}/salary-slip`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/pdf',
      },
    });

    if (!response.ok) {
      throw new Error('Failed to download salary slip');
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    const disposition = response.headers.get('content-disposition') || response.headers.get('Content-Disposition') || '';
    const match = disposition.match(/filename="?([^";]+)"?/);
    const filename = match ? match[1] : `salary_slip_${id}.pdf`;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Download error:', error);
    throw error;
  }
};

// Preview Salary Slip in new tab
export const previewSalarySlip = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const response = await fetch(`${api.defaults.baseURL}/payrolls/${id}/salary-slip`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/pdf',
      },
    });
    if (!response.ok) {
      throw new Error('Failed to load salary slip');
    }
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    window.open(url, '_blank', 'noopener,noreferrer');
  } catch (error) {
    console.error('Preview error:', error);
    throw error;
  }
};

export const downloadTaxInvoicePdf = async (invoices) => {
  try {
    const token = localStorage.getItem('token');
    const response = await fetch(`${api.defaults.baseURL}/excel-uploadsv2/combined/tax-invoice/pdf`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/pdf',
      },
      body: JSON.stringify({ invoices })
    });

    if (!response.ok) {
      throw new Error('Failed to generate PDF');
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `Tax_Invoices_${moment().format('YYYYMMDD_HHmm')}.pdf`;
    document.body.appendChild(link);
    link.click();
    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }, 200);
  } catch (error) {
    console.error('PDF Download error:', error);
    throw error;
  }
};

// Employee Loans
export const getEmployeeLoans = () => api.get('/employee-loans');
export const createEmployeeLoan = (data) => api.post('/employee-loans', data);
export const getEmployeeLoan = (id) => api.get(`/employee-loans/${id}`);
export const updateEmployeeLoan = (id, data) => api.put(`/employee-loans/${id}`, data);
export const deleteEmployeeLoan = (id) => api.delete(`/employee-loans/${id}`);
export const getLoanStatement = (id) => api.get(`/employee-loans/${id}/statement`);
export const makeManualPayment = (id, data) => api.post(`/employee-loans/${id}/manual-payment`, data);
export const getEmployeeLoansByEmployee = (employeeId) => api.get(`/employees/${employeeId}/loans`);
export const getActiveEmployeeLoan = (employeeId) => api.get(`/employee-loans/active/${employeeId}`);

export const sendEmployeeDocuments = (employeeId, data) =>
  api.post(`/employees/${employeeId}/send-documents`, data);

// Get all employee documents (for expiry notification)
export const getEmployeeDocuments = () => api.get('/employee_documents'); // Adjust endpoint as needed

// Get petty cash summary
export const getPettyCashSummary = () => api.get('/petty_cash/summary'); // Adjust endpoint as needed

// Get subcontractor invoices (for notification)
export const getSubcontractorInvoices = () => api.get('/subcontractor_invoices'); // Adjust endpoint as needed

// Get unpaid subcontractor invoices
export const getUnpaidSubcontractorInvoices = () => api.get('/subcontractor_invoices/unpaid');

// Dashboard summary counts
export const getDashboardSummary = () => api.get('/dashboard-summary');

// Email functions

// Timesheet PDF send
export const sendTimesheetPdf = (employee_id, month) => api.post('/employee-timesheets/send-pdf', { employee_id, month });
export const bulkSendTimesheetPdfs = (month) => api.post('/employee-timesheets/bulk-send-pdf', { month });
export const sendTimesheetWhatsapp = (employee_id, month) => api.post('/employee-timesheets/send-whatsapp', { employee_id, month });
export const bulkSendTimesheetWhatsapp = (month) => api.post('/employee-timesheets/bulk-send-whatsapp', { month });
export const previewTimesheetPdf = async (employee_id, month) => {
  const token = localStorage.getItem('token');
  const url = new URL(`${api.defaults.baseURL}/employee-timesheets/preview`);
  url.searchParams.set('employee_id', employee_id);
  url.searchParams.set('month', month);
  const response = await fetch(url.toString(), {
    headers: { 'Authorization': `Bearer ${token}`, 'Accept': 'application/pdf' }
  });
  const contentType = response.headers.get('Content-Type') || '';
  if (!response.ok || !contentType.includes('application/pdf')) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.message || 'Failed to preview PDF');
  }
  return response.blob();
};

// Assignment preview and email send
export const previewAssignmentPdf = async (employee_id, month) => {
  const token = localStorage.getItem('token');
  const url = new URL(`${api.defaults.baseURL}/employee-assignments/preview`);
  url.searchParams.set('employee_id', employee_id);
  url.searchParams.set('month', month);
  const response = await fetch(url.toString(), {
    headers: { 'Authorization': `Bearer ${token}`, 'Accept': 'application/pdf' }
  });
  const contentType = response.headers.get('Content-Type') || '';
  if (!response.ok || !contentType.includes('application/pdf')) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.message || 'Failed to preview assignment PDF');
  }
  return response.blob();
};

export const sendAssignmentEmail = (employee_id, month) => api.post('/employee-assignments/send-email', { employee_id, month });
export const bulkSendAssignmentEmails = (month) => api.post('/employee-assignments/bulk-send-email', { month });

// New getClientBilling API function
export const getClientBilling = (params) => api.get('/billing/clients', { params });

export const exportClientBillingPdf = async (data) => {
  const token = localStorage.getItem('token');
  const response = await fetch(`${api.defaults.baseURL}/billing/clients/export-pdf`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
      'Accept': 'application/pdf',
    },
    body: JSON.stringify(data)
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.message || 'Failed to generate PDF');
  }

  return response.blob();
};

// Add this for subcontractor billing PDF export
export const exportSubcontractorBillingPdf = async (data) => {
  const token = localStorage.getItem('token');
  const response = await fetch(`${api.defaults.baseURL}/billing/subcontractors/export-pdf`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
      'Accept': 'application/pdf',
    },
    body: JSON.stringify(data)
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.message || 'Failed to generate PDF');
  }

  return response.blob();
};

// New getSubcontractorBilling API function
export const getSubcontractorBilling = (params) => api.get('/billing/subcontractors', { params });

export const sendPayslip = (id) => api.post(`/payrolls/${id}/send-payslip`);
export const sendPayslipWatiWhatsapp = (payload) => api.post('/payrolls/whatsapp-send', payload);

// Excel Uploads
export const getExcelUploads = () => api.get('/excel-uploads');
export const uploadExcelFile = (formData) =>
  api.post('/excel-uploads', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const deleteExcelUpload = (id) => api.delete(`/excel-uploads/${id}`);
export const getExcelUpload = (id) => api.get(`/excel-uploads/${id}`);
export const getExcelPreview = (id) =>
  api.get(`/excel-uploads/${id}/preview`, { responseType: 'text', headers: { Accept: 'text/html' } });
export const processExcelUpload = (id) => api.post(`/excel-uploads/${id}/process`);
export const getExcelUploadsByMonthYear = (month, year) => api.get('/excel-uploads/by-month-year', { params: { month, year } });
// New: fetch raw excel_upload_rows by month/year (optionally by upload id)
export const getExcelUploadRowsByMonthYear = (month, year, options = {}) =>
  api.get('/excel-upload-rows/by-month-year', { params: { month, year, ...options } });
export const getTimesheetGrid = (month, params = {}) => api.get('/employee-timesheets/grid', { params: { month, ...params } });
export const getExcelSnapshot = (id) => api.get(`/excel-uploads/${id}/snapshot`);

export const downloadExcelUpload = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const response = await fetch(`${api.defaults.baseURL}/excel-uploads/${id}/download`, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.message || 'Failed to download Excel');
    }
    const blob = await response.blob();
    const disposition = response.headers.get('Content-Disposition') || '';
    const match = disposition.match(/filename="?([^";]+)"?/);
    const filename = match ? match[1] : `excel_${id}`;
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Download Excel error:', error);
    throw error;
  }
};

// New File Uploads API (separate from legacy excel-uploads)
export const getFileUploads = (params) => api.get('/file-uploads', { params });
export const uploadRatesheet = (formData) => api.post('/file-uploads/ratesheet', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const uploadTimesheet = (formData) => api.post('/file-uploads/timesheet', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const getFileUploadPreview = (id) => api.get(`/file-uploads/${id}/preview`, { responseType: 'text', headers: { Accept: 'text/html' } });
export const processFileUpload = (id) => api.post(`/file-uploads/${id}/process`);
export const deleteFileUpload = (id) => api.delete(`/file-uploads/${id}`);
export const downloadFileUpload = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const response = await fetch(`${api.defaults.baseURL}/file-uploads/${id}/download`, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.message || 'Failed to download file');
    }
    const blob = await response.blob();
    const disposition = response.headers.get('Content-Disposition') || '';
    const match = disposition.match(/filename="?([^";]+)"?/);
    const filename = match ? match[1] : `file_${id}`;
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Download file error:', error);
    throw error;
  }
};

export const getDatasheets = (params) => api.get('/datasheets', { params });
export const uploadDatasheet = (formData) => api.post('/datasheets', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const deleteDatasheet = (id) => api.delete(`/datasheets/${id}`);
export const getDatasheet = (id) => api.get(`/datasheets/${id}`);
export const getDatasheetPreview = (id) => api.get(`/datasheets/${id}/preview`, { responseType: 'text', headers: { Accept: 'text/html' } });
export const getDatasheetsByMonthYear = (month, year, type) => api.get('/datasheets/by-month-year', { params: { month, year, type } });
export const processDatasheet = (id) => api.post(`/datasheets/${id}/process`);
export const downloadDatasheet = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const response = await fetch(`${api.defaults.baseURL}/datasheets/${id}/download`, { headers: { 'Authorization': `Bearer ${token}` } });
    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.message || 'Failed to download');
    }
    const blob = await response.blob();
    const disposition = response.headers.get('Content-Disposition') || '';
    const match = disposition.match(/filename="?([^";]+)"?/);
    const filename = match ? match[1] : `datasheet_${id}`;
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    throw error;
  }
};

export const exportAssignmentsPdf = async (filters) => {
  const token = localStorage.getItem('token');
  const response = await fetch(`${api.defaults.baseURL}/employee-assignments/export-pdf`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
      'Accept': 'application/pdf',
    },
    body: JSON.stringify(filters)
  });
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.message || 'Failed to generate PDF');
  }
  return response.blob();
};

// ZIP Payroll remains the same
// ...

// Payment Vouchers
export const getPaymentVouchers = (params) => api.get('/payment-vouchers', { params });
export const createPaymentVoucher = (data) => api.post('/payment-vouchers', data);
export const updatePaymentVoucher = (id, data) => api.put(`/payment-vouchers/${id}`, data);
export const deletePaymentVoucher = (id) => api.delete(`/payment-vouchers/${id}`);

export const downloadPaymentVoucherPdf = async (id, preview = false) => {
  try {
    const token = localStorage.getItem('token');
    const response = await fetch(`${api.defaults.baseURL}/payment-vouchers/${id}/download`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/pdf',
      },
    });

    if (!response.ok) {
      throw new Error('Failed to download voucher');
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    if (preview) {
      window.open(url, '_blank');
    } else {
      const link = document.createElement('a');
      link.href = url;
      link.download = `Voucher_${id}.pdf`;
      document.body.appendChild(link);
      link.click();
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);
    }
  } catch (error) {
    console.error('Download error:', error);
    throw error;
  }
};

export default api;
export const getExcelUploadsV2 = (params) => api.get('/excel-uploadsv2', { params });
export const createExcelUploadV2 = (formData) => api.post('/excel-uploadsv2', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const deleteExcelUploadV2 = (id) => api.delete(`/excel-uploadsv2/${id}`);
export const previewExcelUploadV2 = (id, file = 'timesheet') => api.get(`/excel-uploadsv2/${id}/preview`, { params: { file }, responseType: 'text', headers: { Accept: 'text/html' } });
export const processExcelUploadV2 = (id) => api.post(`/excel-uploadsv2/${id}/process`);
export const downloadExcelUploadV2 = async (id, file = 'timesheet') => {
  const token = localStorage.getItem('token');
  const url = new URL(`${api.defaults.baseURL}/excel-uploadsv2/${id}/download`);
  url.searchParams.set('file', file);
  const response = await fetch(url.toString(), { headers: { 'Authorization': `Bearer ${token}` } });
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.message || 'Failed to download');
  }
  const blob = await response.blob();
  const disposition = response.headers.get('Content-Disposition') || '';
  const match = disposition.match(/filename="?([^";]+)"?/);
  const filename = match ? match[1] : `excel_${id}`;
  const url1 = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url1);
};
export const getRatesheetsV2 = (month, year) => api.get('/excel-uploadsv2/ratesheets', { params: { month, year } });
export const getExcelCombinedV2 = (params) => api.get('/excel-uploadsv2/combined', { params });
export const downloadExcelCombinedV2 = (params) => api.get('/excel-uploadsv2/combined/download', { params, responseType: 'blob' });
export const downloadExcelCombinedV2Pdf = (params) => api.get('/excel-uploadsv2/combined/export-pdf', { params, responseType: 'blob' });
export const updateExcelCombinedRowV2 = (payload) => api.post('/excel-uploadsv2/combined/edit-row', payload);
export const getExcelCombinedRowVersionsV2 = (params) => api.get('/excel-uploadsv2/combined/row-versions', { params });
export const downloadExcelCombinedV2Summary = (params) => api.get('/excel-uploadsv2/combined/export-summary-excel', { params, responseType: 'blob' });
export const downloadExcelCombinedV2SummaryPdf = (params) => api.get('/excel-uploadsv2/combined/export-summary-pdf', { params, responseType: 'blob' });
export const getTaxInvoiceData = (params) => api.get('/excel-uploadsv2/combined/tax-invoice', { params });
export const getTaxInvoiceFilters = (params) => api.get('/excel-uploadsv2/combined/tax-invoice-filters', { params });
export const clearSummaryV2 = (params) => api.post('/excel-uploadsv2/combined/clear-summary', params);
export const deleteCombinedRowV2 = (params) => api.post('/excel-uploadsv2/combined/delete-row', params);

// Saved Tax Invoices CRUD
export const getSavedTaxInvoices = (params) => api.get('/tax-invoices', { params });
export const saveTaxInvoice = (data) => api.post('/tax-invoices', data);
export const getNextInvoiceNumber = () => api.get('/tax-invoices/next-number');
export const updateSavedTaxInvoice = (id, data) => api.put(`/tax-invoices/${id}`, data);
export const deleteSavedTaxInvoice = (id) => api.delete(`/tax-invoices/${id}`);
export const getSavedTaxInvoice = (id) => api.get(`/tax-invoices/${id}`);

// Independent SOA Ledger CRUD
export const getSoaEntries = (params) => api.get('/soa-entries', { params });
export const addSoaEntry = (data) => api.post('/soa-entries', data);
export const updateSoaEntry = (id, data) => api.put(`/soa-entries/${id}`, data);
export const deleteSoaEntry = (id) => api.delete(`/soa-entries/${id}`);
export const recordSoaPayment = (id, amount) => api.post(`/soa-entries/${id}/record-payment`, { amount });
export const downloadSoaIndependent = async (params) => {
  const token = localStorage.getItem('token');
  const url = new URL(`${api.defaults.baseURL}/soa-entries/download`);
  Object.keys(params).forEach(key => {
    if (params[key]) url.searchParams.append(key, params[key]);
  });
  const response = await fetch(url.toString(), { headers: { 'Authorization': `Bearer ${token}` } });
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.message || 'Failed to download SOA');
  }
  return response.blob();
};

// ZIP Payroll
export const initZipPayroll = () => api.post('/payrolls/zip-init');
export const addSlipToZipPayroll = (payload) => api.post('/payrolls/zip-add', payload);
export const finalizeZipPayroll = async (zipId, filename = 'payslips.zip') => {
  try {
    const response = await api.get('/payrolls/zip-final', {
      params: { zip_id: zipId },
      responseType: 'blob'
    });

    // Axios returns the blob in .data if responseType is 'blob'
    // But our interceptor might have wrapped it if it was mistaken for a regular object
    // or returned it directly. Let's handle both.
    const blob = response.data instanceof Blob ? response.data : (response.data?.data instanceof Blob ? response.data.data : null);

    if (!blob) throw new Error('No file data received');

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();

    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }, 100);

    return { success: true };
  } catch (error) {
    console.error('ZIP Finalize error:', error);
    throw error;
  }
};

// Simplified Employee Leaves management API
export const getEmployeeLeaves = (params) => api.get('/employee-leaves', { params });
export const createEmployeeLeave = (formData) => api.post('/employee-leaves', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const updateEmployeeLeave = (id, formData) => api.post(`/employee-leaves/${id}?_method=PUT`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const deleteEmployeeLeave = (id) => api.delete(`/employee-leaves/${id}`);

// Blank Timesheets
export const getBlankTimesheets = (params) => api.get('/blank-timesheets', { params });
export const parseBlankTimesheetExcel = (formData) => api.post('/blank-timesheets', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const exportBlankTimesheetsPdf = async (params) => {
  const token = localStorage.getItem('token');
  const url = new URL(`${api.defaults.baseURL}/blank-timesheets/export-pdf`);
  Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));

  const response = await fetch(url.toString(), {
    headers: { 'Authorization': `Bearer ${token}` }
  });
  if (!response.ok) throw new Error('Failed to download PDF');
  return response.blob();
};
export const exportBlankTimesheetsZip = async (params) => {
  const token = localStorage.getItem('token');
  const url = new URL(`${api.defaults.baseURL}/blank-timesheets/export-zip`);
  Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));

  const response = await fetch(url.toString(), {
    headers: { 'Authorization': `Bearer ${token}` }
  });
  if (!response.ok) throw new Error('Failed to download ZIP');
  return response.blob();
};

// Check Printing
export const getCheckPrintRecords = (params = {}) => api.get('/check-print-records', { params });
export const uploadCheckPrintExcel = (formData) => api.post('/check-print-records', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const downloadCheckSample = () => {
  const token = localStorage.getItem('token');
  return fetch(`${api.defaults.baseURL}/check-print-records/sample-template`, {
    headers: { 'Authorization': `Bearer ${token}` }
  }).then(res => res.blob());
};
export const deleteCheckRecord = (id) => api.delete(`/check-print-records/${id}`);
export const clearCheckRecords = () => api.delete('/check-print-records/clear');
export const exportChecksPdf = async (ids) => {
  const token = localStorage.getItem('token');
  const response = await fetch(`${api.defaults.baseURL}/check-print-records/export-pdf`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ ids })
  });
  if (!response.ok) throw new Error('Failed to download Check PDF');
  return response.blob();
};
